export const EXCLUDED_HEALTH_PLAN_IDS = ['HP8', 'HP9'];
export const EXCLUDED_HEALTH_PLANS = ["Excellus BlueCross BlueShield", "Univera Healthcare"];
export const LAST_MAX_DATE = new Date(2026, 5, 30);
export const LAST_MAX_DATE_INITIAL = new Date(2026, 4, 7);